import React, {Component} from 'react';
import {Button, Table} from "reactstrap";
import 'moment/locale/fr';
import './Products.css'
import {Download, Edit2, Mail, Trash} from "react-feather";
import {Col, OverlayTrigger, Row, ToggleButton, ToggleButtonGroup, Tooltip} from "react-bootstrap";
import AddUserModalForm from "./modals/AddUserModal";
import DeleteModal from "./modals/DeleteModal";
import Moment from "react-moment";
import CsvDownloadButton from 'react-json-to-csv'
import {AiOutlineInstagram, AiFillLinkedin} from "react-icons/ai";
import {BsFacebook} from "react-icons/bs";
import {BiRun} from "react-icons/bi";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import AddAmbassadorModal from './modals/AddAmbassadorModal';
import ModifyAmbassadorModal from './modals/ModifyAmbassadorModal';
import AddAffiliateModal from './modals/AddAffiliateModal';
import DeleteAffiliateModal from './modals/DeleteAffiliateModal';
import {ReactSortable} from "react-sortablejs";
import { apiFetch, API } from "../services/api";

function getAffiliateList() {

    return apiFetch(API.back + '/affiliates', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

export class AffiliateList extends Component {
    state = {
        errors: null,
        csvUsers: null,
    }

    constructor(props) {
        super(props);
        this.closeModal = this.closeModal.bind(this);
                this.handleNewDropSlides = this.handleNewDropSlides.bind(this);
    }

    async componentDidMount() {
        await getAffiliateList().then(data => {
            const uniqueNames = data
            this.setState({users: uniqueNames})
        }).catch(err =>
            this.setState({errors: "error while getting users"})
        );
    };

    closeModal() {
        this.setState({isOpen: false, isOpenModify: false})
    } 

    handleNewDropSlides(list) {
        if (JSON.stringify(list) !== JSON.stringify(this.state.users)) {
           this.setState({sortingSlides: list});

           const newBoxState = list.map((slide, index) => {
            slide.order = '' + index

            fetch('https://back-api.therunningcollective.fr/affiliate', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(slide)
            }).then(this.props.closeModal)
                .catch( err =>
                    console.log(err)
                )

            return slide;
        });

        this.setState({users : newBoxState});
         }
       }


    render() {
        return (
            <div className="products-list">
                <Row>
                    <Col sm={9} className="products-buttons">
                        {(this.state.users && this.state.errors == null) ? <span>{this.state.users.length} comptes client</span> : null }
                    </Col>
                    <Col sm={3} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"
                                onClick={(e) => this.setState({isOpen: true})}>Ajouter un affilié</Button>
                    </Col>
                </Row>

                { (!this.state.users && this.state.errors == null) ? <p> Chargement ...</p>
                    :
                    <Table responsive>
                        <thead>

                        </thead>
                        <tbody>
                            {this.state.users && 
                        <ReactSortable 
                                list={this.state.users} 
                                setList={this.handleNewDropSlides}>
                        { this.state.users.map(user => (
                            <tr>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Affilié affiché sur la page récap?</Tooltip>}
                                >
                                    <td><BootstrapSwitchButton
                                        checked={user.showOnSelection}
                                        onlabel='oui'
                                        onstyle='success'
                                        offlabel='non'
                                        offstyle='danger'
                                        size='xs'
                                        onChange={(checked: boolean) => {
                                            updateContactedState(user, checked)
                                        }}
                                    /></td>
                                </OverlayTrigger>
                                <td>{user.user.name}</td>
                                <td>{user.user.firstName}</td>
                                <td>{user.user.gender}</td>
                                <td>{calculateAge(user.user.birthdayDate) + " ans"}</td>
                                <td>{user.user.address} <br/> {user.zipCode} {user.town}</td>
                                <td>{user.user.email}</td>
                                <td>{user.user.phoneNumber}</td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">CPA</Tooltip>}
                                >
                                    <td>{user.cpa}€</td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">CPC</Tooltip>}
                                >
                                    <td>{user.cpc}€</td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">CP Création compte</Tooltip>}
                                >
                                    <td>{user.cpCreate}€</td>
                                </OverlayTrigger>
                                <td><Moment to={user.user.lastConnexion} locale="fr">{Date.now()}</Moment></td>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Modifier l'affilié</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: 'pointer'}}>
                                        <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpenModify : true, selectedUser : user})}/>
                                    </td>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<Tooltip id="button-tooltip">Supprimer l'affilié</Tooltip>}
                                >
                                    <td className="table-action" style={{cursor: "pointer"}}>
                                        <Trash className="align-middle" size={18}
                                                onClick={(e) => this.setState({isDelete: true, selectedUser: user})}/>
                                    </td>
                                </OverlayTrigger>
                            </tr>
                        ))}
                        </ReactSortable>}
                        </tbody>
                    </Table>
                }
                {this.state.isOpen ?
                    <AddAffiliateModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                    />
                    :
                    null
                }
                {this.state.isOpenModify ?
                    <AddAffiliateModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpenModify}
                        handleSubmit={this.handleSubmit}
                        user={this.state.selectedUser}
                    />
                    :
                    null
                }
                {this.state.isDelete ?
                    <DeleteAffiliateModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedUser.user}
                        selectedCategory="affiliate"
                    />
                    :
                    null
                }
            </div>
        );

    }
}

function updateContactedState(user, checked) {
    user.showOnSelection = checked
    return fetch('https://back-api.therunningcollective.fr/affiliate', {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

const calculateAge = (dob1) => {
    var today = new Date();
    var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
    var age_now = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate()))
    {
        age_now--;
    }
    return age_now;
}